/* Santas Vault - the "Make it theirs" picker.
   ------------------------------------------------------------------
   ONE SCREEN. Product kind across the top, the look as a chip row, the designs
   in a grid, and the chosen design with its name and its Add button in a panel
   beside them. Nothing hides anything else and nothing navigates until the end.

   THIS FILE ONCE DROVE A THREE STEP WIZARD and the markup was replaced with the
   one screen above without it. `boot()` then asked for [data-back], which no
   longer exists, and `null.addEventListener` threw on line one of the wiring -
   before a single chip or tile was drawn. The containers rendered empty, so the
   live page showed the word "Look", an empty panel and nothing else, and it did
   that for hours because a broken picker looks like a slow picker. The lesson is
   in CLAUDE.md: when a template is replaced, the script that reads it is part of
   the same change, and the page has to be opened afterwards.

   THE THREE THINGS THAT MAKE IT FEEL FAST, and they are all the same idea:
   never go back to the server.

   1. ONE FETCH. The whole index arrives as one JSON asset on first paint. Six
      hundred designs is about 90 KB, which is one photograph, and after that
      every step is a filter over an array in memory.
   2. LAZY IMAGES, PAGED GRID. Rendering six hundred <img> tags at once locks a
      mid range phone for a second and a half. The grid renders 36 at a time
      behind a "show more", every image is loading="lazy" with real width and
      height so nothing reflows, and the Shopify CDN is asked for a 400 px
      version rather than the 600 px master.
   3. NO ROUTE CHANGE UNTIL THE END. The shopper only leaves this page once, and
      they leave it carrying the name in the URL, so the product page opens with
      the field already filled and the preview already drawn.

   THE NAME IS CARRIED AS ?name= AND NOTHING ELSE. It is the shopper's own text
   going back to the shopper's own browser, it is capped at 14 characters, and it
   is written with encodeURIComponent, so there is nothing here to inject with.
   The product page's own personalisation code owns validation from that point.
*/
(function () {
  var PAGE = 36;

  function $(s, r) { return (r || document).querySelector(s); }
  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  /* Ask the CDN for the size actually being shown. A 600 px master in a 190 px
     tile is four times the bytes for no visible gain, and on a phone in a car
     park that is the difference between usable and not. */
  function thumb(url, w) {
    if (!url) return '';
    return url.indexOf('?') > -1
      ? url.replace(/([?&])width=\d+/, '$1width=' + w)
      : url + '?width=' + w;
  }

  function boot(root) {
    var state = { kind: null, theme: null, design: null, shown: PAGE, data: null };

    function kindLabel() {
      var k = (state.data.kinds || []).filter(function (x) { return x[0] === state.kind; })[0];
      return k ? k[1] : '';
    }

    /* ---------------------------------------------------------- step 1 */
    function drawKinds() {
      var wrap = $('[data-kinds]', root);
      wrap.innerHTML = '';
      state.data.kinds.forEach(function (k) {
        var b = el('button', 'sv-kind');
        b.type = 'button';
        // THE PICTURE IS THE POINT OF THIS STEP. A labelled box with a price is
        // a menu; a photograph of the mug is a shop.
        b.innerHTML =
          (k[4] ? '<img class="sv-kind__img" src="' + esc(thumb(k[4], 500)) +
                  '" alt="" loading="lazy" width="500" height="500">'
                : '<span class="sv-kind__img sv-kind__img--none"></span>') +
          '<span class="sv-kind__t">' + esc(k[1]) + '</span>' +
          '<span class="sv-kind__p">from $' + esc(k[2]) + '<span class="sv-kind__n">' +
          k[3] + ' designs</span></span>';
        b.dataset.k = k[0];
        b.addEventListener('click', function () {
          state.kind = k[0];
          state.theme = null;
          markKinds();
          drawThemes();
          drawGrid();
        });
        wrap.appendChild(b);
      });
    }

    function markKinds() {
      var chips = root.querySelectorAll('[data-kinds] .sv-kind');
      for (var i = 0; i < chips.length; i++) {
        chips[i].classList.toggle('is-on', chips[i].dataset.k === state.kind);
      }
    }

    function designsFor(kind, theme) {
      return state.data.designs.filter(function (d) {
        if (kind && d[4].indexOf(kind) < 0) return false;
        if (theme && d[2] !== theme) return false;
        return true;
      });
    }

    function drawThemes() {
      var wrap = $('[data-themes]', root);
      wrap.innerHTML = '';
      var all = el('button', 'sv-theme sv-theme--all');
      all.type = 'button';
      all.innerHTML = '<span class="sv-theme__t">Show me everything</span>' +
        '<span class="sv-theme__n">' + designsFor(state.kind, null).length + ' designs</span>';
      all.addEventListener('click', function () { state.theme = null; drawGrid(); mark(); });
      wrap.appendChild(all);

      state.data.themes.forEach(function (t) {
        var n = designsFor(state.kind, t[0]).length;
        if (!n) return;                       // a theme with nothing on this
        var b = el('button', 'sv-theme');     // product is not an option
        b.type = 'button';
        b.dataset.k = t[0];
        b.innerHTML = '<span class="sv-theme__t">' + esc(t[1]) + '</span>' +
                      '<span class="sv-theme__n">' + n + '</span>';
        b.addEventListener('click', function () { state.theme = t[0]; drawGrid(); mark(); });
        wrap.appendChild(b);
      });
      mark();
    }

    /* which chip is on. The chips filter the grid underneath them rather than
       navigating, so the selected state has to be visible or the shopper cannot
       tell what they are looking at. */
    function mark() {
      var chips = root.querySelectorAll('[data-themes] .sv-theme');
      for (var i = 0; i < chips.length; i++) {
        var on = (i === 0) ? (state.theme === null)
                           : (chips[i].dataset.k === state.theme);
        chips[i].classList.toggle('is-on', on);
      }
    }

    /* ---------------------------------------------------------- step 3 */
    function drawGrid(append) {
      var grid = $('[data-grid]', root);
      var more = $('[data-more]', root);
      var list = designsFor(state.kind, state.theme);
      if (!append) { grid.innerHTML = ''; state.shown = PAGE; }
      var from = append ? grid.children.length : 0;
      list.slice(from, state.shown).forEach(function (d) {
        var b = el('button', 'sv-pick');
        b.type = 'button';
        b.innerHTML =
          '<img class="sv-pick__img" src="' + esc(thumb(d[3], 400)) + '" alt="' + esc(d[1]) +
          '" loading="lazy" width="400" height="400">' +
          '<span class="sv-pick__t">' + esc(d[1]) + '</span>';
        b.dataset.d = d[0];
        b.addEventListener('click', function () {
          state.design = d;
          var on = root.querySelectorAll('[data-grid] .sv-pick');
          for (var i = 0; i < on.length; i++) {
            on[i].classList.toggle('is-on', on[i].dataset.d === String(d[0]));
          }
          drawFinal();
        });
        grid.appendChild(b);
      });
      $('[data-count]', root).textContent =
        list.length + ' ' + kindLabel().toLowerCase() + ' designs' +
        (state.theme ? '' : ' across every look');
      more.hidden = list.length <= state.shown;
      more.textContent = 'Show ' + Math.min(PAGE, list.length - state.shown) + ' more';
    }

    /* ------------------------------------------------------------- panel
       The panel is on screen the whole time now, so this fills it rather than
       revealing it. It does NOT clear the name field: on a wizard the name was
       typed after the design, on one screen a shopper may type it first and
       then browse, and wiping their typing because they changed their mind
       about the picture is the rudest thing this page could do. */
    function drawFinal() {
      var d = state.design;
      var img = $('[data-preview-img]', root);
      img.src = thumb(d[3], 700);
      img.alt = d[1];
      img.hidden = false;
      $('[data-chosen]', root).textContent = d[1] + ', on a ' + kindLabel().toLowerCase() + '.';
      paint();
      // On a phone the panel is below the grid, so bring it into view. On a
      // desktop it is already beside the grid and scrolling would be wrong.
      if (!window.matchMedia('(min-width:900px)').matches) {
        $('.sv-cz__panel', root).scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }

    function paint() {
      var input = $('#sv-cz-name', root);
      var name = (input.value || '').slice(0, 14);
      $('[data-preview-name]', root).textContent = name || ' ';
      $('[data-chars]', root).textContent = name.length;
      var go = $('[data-go]', root);
      // Handle = slug + the suffix for this product kind, unless the index
      // recorded an exception for this design (index 6), which it does whenever
      // a real live handle does not follow the pattern.
      var d = state.design, handle = null;
      if (d) {
        handle = (d[6] && d[6][state.kind]) ||
                 (d[5] + (state.data.sfx[state.kind] || ''));
      }
      if (!handle) { go.setAttribute('aria-disabled', 'true'); return; }
      go.href = '/products/' + handle + (name ? '?name=' + encodeURIComponent(name) : '');
      go.removeAttribute('aria-disabled');
      go.textContent = name ? 'Choose size and add to cart' : 'Skip the name and see it';
    }

    /* ------------------------------------------------------------ wire
       EVERY HOOK IS OPTIONAL. The last version assumed five elements existed
       and threw on the first one that did not, taking the whole picker with it.
       A missing control should cost that control, not the page. */
    function on(sel, ev, fn) {
      var n = $(sel, root);
      if (n) n.addEventListener(ev, fn);
      return !!n;
    }
    on('[data-more]', 'click', function () { state.shown += PAGE; drawGrid(true); });
    on('#sv-cz-name', 'input', paint);

    fetch(root.getAttribute('data-src'))
      .then(function (r) { return r.json(); })
      .then(function (j) {
        state.data = j;
        root.classList.add('is-ready');
        // Land on the first kind rather than on an empty screen. "Pick a
        // product type to see designs" is a screen that shows nothing, and
        // Tony's instruction was the opposite of that: give them the products.
        state.kind = (j.kinds && j.kinds.length) ? j.kinds[0][0] : null;
        drawKinds();
        markKinds();
        drawThemes();
        drawGrid();
        paint();
      })
      .catch(function () {
        root.classList.add('is-failed');
        $('[data-kinds]', root).innerHTML =
          '<p>The design picker could not load. Every design is still on the shelves: ' +
          '<a href="/collections/personalised">browse everything personalised</a>.</p>';
      });
  }

  function start() {
    var root = document.querySelector('[data-sv-create]');
    if (root && !root.dataset.svOn) { root.dataset.svOn = '1'; boot(root); }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else { start(); }
  document.addEventListener('shopify:section:load', start);
})();
